export default __webpack_public_path__ + "static/media/sunset.83c01dc2.png";